import React, { FC, useCallback, useLayoutEffect, useState } from 'react';

import { useLocation } from 'react-router';
import ModalPanel from '../../components/Modal/Wrapper'
import queryString from 'query-string';
import {ModalRight, BackDrop, ModalClose} from '../../components/Modal';
import LoginPage from '../Login/Loadable';
import RegisterPage from '../Register/Loadable'
import EmailVerifyPage from '../Register/EmailVerify/Loadable'
import ContactForm from '../App/ContactForm/Loadable';
import ForgotPasswordPage from '../ForgotPassword/Loadable';
import NewPasswordPage from '../ForgotPassword/Reset/Loadable';
import { UserService } from '../../services/UserService';
import ResetPasswordPhoneNumber from '../ForgotPassword/ResetPasswordPhoneNumber';

interface IModal {
  isOpen : boolean
}

const Modal: FC<IModal> = () => {

  const location = useLocation();
  const searchParams = queryString.parse(location.search);
  
  const [open, setOpen] = useState<boolean>(searchParams.modal === 'true' ? true : false);

  const storage = UserService.getJwtFromLocalStorage()
  const isAuth = storage && storage.token ? true : false

  const close = useCallback(()=>{
     //history.push(`${location.pathname}`);
     setOpen(false);
  },[location])

  useLayoutEffect(() => {
      const closeModal = (e: KeyboardEvent) => {
        const { key } = e
        if(key === "Escape"){
          close()
        }
      }
      window.addEventListener('keydown', closeModal)
    return () => window.removeEventListener('keydown', closeModal)
  },[])

  useLayoutEffect(() => {
   
    if(open !== true) {
      setOpen(searchParams.modal === 'true' ? true : false);
    }
    
  },[searchParams.modal])

  return (
    open ?  
      <ModalPanel>
        <ModalRight id={'modalRightId'} className="showModal">
          <BackDrop onClick={close} className="modalBackdrop"></BackDrop>
          <ModalClose onClick={close}><svg><use xlinkHref={`#close`} /></svg></ModalClose>
          {
            searchParams.LoginPage === 'true' && !isAuth  ? <LoginPage /> :
            searchParams.RegisterPage === 'true' && !isAuth ? <RegisterPage /> :
            searchParams.ForgotPasswordPage === 'true' && !isAuth ? <ForgotPasswordPage /> :
            searchParams.NewPasswordPage === 'true' && !isAuth ? <NewPasswordPage /> :
            searchParams.NewPasswordPagePhone === 'true' && !isAuth ? <ResetPasswordPhoneNumber /> :
            searchParams.EmailVerifyPage === 'true' && !isAuth ? <EmailVerifyPage /> : 
            searchParams.ContactForm === 'true' ? <ContactForm /> : null 
            
          }
        </ModalRight>
      </ModalPanel> 
    : null 
   )
};

export default Modal;
